import React, { useState, useMemo } from 'react';
import { menuData } from '../data/mock';
import MenuHeader from '../components/MenuHeader';
import MenuSection from '../components/MenuSection';
import DietaryFilter from '../components/DietaryFilter';
import Footer from '../components/Footer';

// Navigation config: each entry scrolls to a section OR subgroup
const NAV_ITEMS = [
  { label: 'Appetizers',     target: 'appetizers' },
  { label: 'Soups',          target: 'soups' },
  { label: 'Noodles',        target: 'stirfry-noodles' },
  { label: 'Stir Fry',       target: 'stirfry-stir-fry' },
  { label: 'Curry',          target: 'stirfry-thai-curry' },
  { label: 'Fried Rice',     target: 'stirfry-fried-rice' },
  { label: "Ploy's Specials",target: 'specials' },
  { label: 'Salads',         target: 'salads' },
  { label: 'Sides',          target: 'sides' },
  { label: 'Drinks',         target: 'drinks' },
  { label: 'Desserts',       target: 'desserts' }
];

const MenuPage = () => {
  const { restaurantInfo, menuSections } = menuData;
  const [activeFilters, setActiveFilters] = useState([]);

  const toggleFilter = (code) => {
    setActiveFilters((curr) =>
      curr.includes(code) ? curr.filter((c) => c !== code) : [...curr, code]
    );
  };
  const clearFilters = () => setActiveFilters([]);

  const matches = (item) =>
    activeFilters.every((f) => (item.tags || []).includes(f));

  const filteredSections = useMemo(() => {
    if (activeFilters.length === 0) return menuSections;
    return menuSections.map((section) => {
      const filtered = { ...section };
      if (section.items) {
        filtered.items = section.items.filter(matches);
      }
      if (section.subgroups) {
        filtered.subgroups = section.subgroups.map((sg) => ({
          ...sg,
          items: (sg.items || []).filter(matches)
        }));
      }
      return filtered;
    });
  }, [activeFilters, menuSections]);

  return (
    <div
      className="min-h-screen bg-[#2B130F] relative"
      data-testid="menu-page"
      style={{
        backgroundImage:
          "radial-gradient(circle at 20% 20%, rgba(232,185,69,0.03) 0%, transparent 40%), radial-gradient(circle at 80% 60%, rgba(232,185,69,0.025) 0%, transparent 45%)"
      }}
    >
      <MenuHeader navItems={NAV_ITEMS} />

      <DietaryFilter
        activeFilters={activeFilters}
        onToggle={toggleFilter}
        onClear={clearFilters}
      />

      <main className="pb-4">
        {filteredSections.map((section) => (
          <div key={section.id} data-section={section.id} className="scroll-mt-24">
            <MenuSection section={section} />
          </div>
        ))}
      </main>

      <Footer restaurantInfo={restaurantInfo} />
    </div>
  );
};

export default MenuPage;
